import MarkersMap from "./PositionsMap";
import ConnectionsMap from "./ConnectPointsMap"
//import GreeceMap from "./Connections&PositionsMap"
import Zones from "./RoadTransportZones";
import SelectedZones from "./RoadTranportSelectedZones"
import Lanes from "./NumberOfLanes"

function MidPage({ThemeSelection, RoadTransportThemeSelection,TransportMeansSelection, OriginSelectorValue, destinations}) {
    

    if(ThemeSelection.length === 1){
        if(ThemeSelection.includes("Θέση")){
            return <MarkersMap TransportMeansSelection = {TransportMeansSelection}></MarkersMap>
        }
        
        else{
            if(OriginSelectorValue.length !== 0 && destinations.length !== 0) {
              return <ConnectionsMap OriginSelectorValue = {OriginSelectorValue} destinations = {destinations} TransportMeansSelection = {TransportMeansSelection}></ConnectionsMap>
            }
            else {
              return <></>
            }
        }
    }

    if(RoadTransportThemeSelection[0].includes("Θέση")){
      return <MarkersMap TransportMeansSelection = {TransportMeansSelection}></MarkersMap>
    }


    if(RoadTransportThemeSelection[0].includes("Κυκλοφοριακές ζώνες")){
      return <Zones></Zones>
    }

    if(RoadTransportThemeSelection[0].includes('Μετακινήσεις (ΕΜΗΚ) μεταξυ κυκλοφοριακών ζωνών')){
      if(OriginSelectorValue.length !== 0 && destinations.length !== 0) {
        return <SelectedZones StartingPoint={OriginSelectorValue} DestinationPoint ={destinations}></SelectedZones>
      }
      else {
        return <></>
      }
    }

    if(RoadTransportThemeSelection[0].includes("Οδικά Τμήματα")){
      return <Lanes selection = {RoadTransportThemeSelection}></Lanes>
    
    }






  return (
    <></>

    
  );
}

export default MidPage;
